import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Table, type Column } from "@freightsimple/ui-core/Table/Table";
import { TextCell } from "@freightsimple/ui-core/Cells/TextCell";
import type { OpportunityBreakdown } from "@freightsimple/generated-carriers-openapi-client/models/OpportunityBreakdown";
import { formatPercent } from "@/App/Views/carrierFormatting";

/**
 * A labelled slice of a customer's shipments with its share of the whole.
 *
 * Origins, months, weight bands and density bands are all the same shape, so
 * they're all this table. What differs is the question each answers, which is
 * what the title and the column header carry.
 */
export function OpportunityBreakdownPanel({
  title,
  description,
  header,
  rows,
  emptyMessage,
}: {
  title: string;
  description: string;
  header: string;
  rows: OpportunityBreakdown[];
  emptyMessage: string;
}) {
  const columns: Column<OpportunityBreakdown>[] = [
    {
      key: "label",
      header,
      render: (row) => <TextCell value={row.label} />,
    },
    {
      key: "count",
      header: "Shipments",
      align: "right",
      render: (row) => (
        <TextCell value={row.shipmentCount.toLocaleString("en-CA")} />
      ),
    },
    {
      key: "share",
      header: "Share",
      align: "right",
      render: (row) => (
        <TextCell value={formatPercent(row.sharePercentage)} color="muted" />
      ),
    },
  ];

  return (
    <Panel title={title} description={description} fullBleed>
      <Table
        columns={columns}
        data={rows}
        rowKey={(row) => row.label}
        emptyMessage={emptyMessage}
      />
    </Panel>
  );
}
